var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-layout",
    style: _vm.colorObject
  }, [_vm.isLoading ? _c('Loading', {
    attrs: {
      "loading-message": "載入中...",
      "background-color": '#ffffff'
    }
  }) : _vm._e(), _c('div', {
    staticClass: "s-container"
  }, [_c('div', {
    staticClass: "content",
    style: _vm.colors
  }, [_c('div', {
    staticClass: "custom-elanco-header"
  }, [_c('span', {
    staticClass: "custom-elanco-header__text"
  }, [_vm._v("Hi " + _vm._s(_vm.deepGet(_vm.user, 'name')))]), _c('a', {
    attrs: {
      "href": _vm.deepGet(_vm.event, 'config.header_logo_url', '#')
    }
  }, [_vm.deepGet(_vm.event, 'config.images.header_logo') ? _c('img', {
    staticClass: "custom-elanco-header__image ml-3",
    attrs: {
      "src": _vm.deepGet(_vm.event, 'config.images.header_logo')
    }
  }) : _vm._e()])]), _c('div', {
    staticClass: "scanner-view"
  }, [_c('div', {
    staticClass: "scanner-view__body"
  }, [_c('div', {
    staticClass: "scanner-view__title mb-3"
  }, [_vm._v("請將 QR code 對準框線")]), _c('QRCodeScanner', {
    ref: "qrScanner",
    staticClass: "scanner-view__scanner",
    attrs: {
      "qrbox": _vm.qrbox
    },
    on: {
      "onScan": _vm.handleQrCodeIsScanned
    }
  }), _c('button', {
    staticClass: "scanner-view__close s-btn s-btn-outline-primary s-btn-xs mt-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleCloseScannerButtonIsClicked
    }
  }, [_vm._v(" 取消 ")])], 1)])])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }